const GROSS_REVENUE = 'Gross Revenue';
const GROSS_REVENUE_KEY = 'gross_revenue_monthly_actual';
const GROSS_REVENUE_TARGET = 'Gross Revenue Target';
const GROSS_REVENUE_TARGET_KEY = 'gross_revenue_monthly_budget';
const GROSS_REVENUE_COMPLETION = 'Gross Revenue Completion';
const GROSS_REVENUE_COMPLETION_KEY = 'gross_revenue_monthly_completion';
const GROSS_REVENUE_YTM = 'Gross Revenue YTM';
const GROSS_REVENUE_YTM_KEY = 'gross_revenue_ytm_actual';
const GROSS_REVENUE_TARGET_YTM = 'Gross Revenue Target Annual';
const GROSS_REVENUE_TARGET_YTM_KEY = 'gross_revenue_annual_budget';
const GROSS_REVENUE_YTM_COMPLETION = 'Gross Revenue YTM Completion';
const GROSS_REVENUE_YTM_COMPLETION_KEY = 'gross_revenue_annual_completion';
const NET_PROFIT = 'Net Profit';
const NET_PROFIT_KEY = 'net_profit_monthly_actual';
const NET_PROFIT_TARGET = 'Net Profit Target';
const NET_PROFIT_TARGET_KEY = 'net_profit_monthly_budget';
const NET_PROFIT_COMPLETION = 'Net Profit Completion';
const NET_PROFIT_COMPLETION_KEY = 'net_profit_monthly_completion';
const NET_PROFIT_YTM = 'Net Profit YTM';
const NET_PROFIT_YTM_KEY = 'net_profit_ytm_actual';
const NET_PROFIT_TARGET_YTM = 'Net Profit Target Annual';
const NET_PROFIT_TARGET_YTM_KEY = 'net_profit_annual_budget';
const NET_PROFIT_YTM_COMPLETION = 'Net Profit YTM Completion';
const NET_PROFIT_YTM_COMPLETION_KEY = 'net_profit_annual_completion';

// 接口返回字段前端使用映射表
export const RES_FIELDS_MAP: any = {
  [GROSS_REVENUE]: {
    key: GROSS_REVENUE_KEY,
    yoy: true,
    mom: true,
  },
  [GROSS_REVENUE_TARGET]: {
    key: [GROSS_REVENUE_TARGET_KEY],
  },
  [GROSS_REVENUE_COMPLETION]: {
    key: GROSS_REVENUE_COMPLETION_KEY,
  },
  [GROSS_REVENUE_YTM]: {
    key: GROSS_REVENUE_YTM_KEY,
    yoy: true,
    mom: true,
  },
  [GROSS_REVENUE_TARGET_YTM]: {
    key: GROSS_REVENUE_TARGET_YTM_KEY,
  },
  [GROSS_REVENUE_YTM_COMPLETION]: {
    key: GROSS_REVENUE_YTM_COMPLETION_KEY,
  },
  [NET_PROFIT]: {
    key: NET_PROFIT_KEY,
    yoy: true,
    mom: true,
  },
  [NET_PROFIT_TARGET]: {
    key: NET_PROFIT_TARGET_KEY,
  },
  [NET_PROFIT_COMPLETION]: {
    key: NET_PROFIT_COMPLETION_KEY,
  },
  [NET_PROFIT_YTM]: {
    key: [NET_PROFIT_YTM_KEY],
    yoy: true,
    mom: true,
  },
  [NET_PROFIT_TARGET_YTM]: {
    key: NET_PROFIT_TARGET_YTM_KEY,
  },
  [NET_PROFIT_YTM_COMPLETION]: {
    key: NET_PROFIT_YTM_COMPLETION_KEY,
  },
};

// 排序传参字段映射表
export const SORT_REQ_MAP: any = {
  studio: 'studio_name',
  project: 'game_name',
  [GROSS_REVENUE_KEY]: GROSS_REVENUE,
  // [GROSS_REVENUE_TARGET_KEY]: GROSS_REVENUE_TARGET,
  // [GROSS_REVENUE_COMPLETION_KEY]: GROSS_REVENUE_COMPLETION,
  gross_revenue_monthly_budget_and_completion: GROSS_REVENUE_TARGET,
  [GROSS_REVENUE_YTM_KEY]: GROSS_REVENUE_YTM,
  // [GROSS_REVENUE_TARGET_YTM_KEY]: GROSS_REVENUE_TARGET_YTM,
  // [GROSS_REVENUE_YTM_COMPLETION_KEY]: GROSS_REVENUE_YTM_COMPLETION,
  gross_revenue_annual_budget_and_completion: GROSS_REVENUE_TARGET_YTM,
  [NET_PROFIT_KEY]: NET_PROFIT,
  // [NET_PROFIT_TARGET_KEY]: NET_PROFIT_TARGET,
  // [NET_PROFIT_COMPLETION_KEY]: NET_PROFIT_COMPLETION,
  net_profit_monthly_budget_and_completion: NET_PROFIT_TARGET,
  [NET_PROFIT_YTM_KEY]: NET_PROFIT_YTM,
  // [NET_PROFIT_TARGET_YTM_KEY]: NET_PROFIT_TARGET_YTM,
  // [NET_PROFIT_YTM_COMPLETION_KEY]: NET_PROFIT_YTM_COMPLETION,
  net_profit_annual_budget_and_completion: NET_PROFIT_TARGET_YTM,
};
